import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { DatePicker } from 'antd';
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { FaLock, FaSignInAlt, FaEye, FaEnvelope} from "react-icons/fa";
import 'antd/dist/antd.css';
import C from '../lib/Config';
const dateFormat = 'DD/MM/yyyy';

function passwordShow() {
    var x = document.getElementById("myInput");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
}

export default class ForgotPassword extends Component {

    constructor(props) {
        super(props)
        this.state = {
            redirectToLogin: false,
            emailId: '',
            dob: '',
            otp: '',
            password: '',
            confirmpassword: '',
            confirmPasswordVisible: false,
            generateOtpLoader: false,
            Messages: [],
            errors: {}
        }
        this.handleChange = this.handleChange.bind(this);
        this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
        this.toggleConfirmPasswordVisibility = this.toggleConfirmPasswordVisibility.bind(this);
    }

    validateForm() {
        let formIsValid = true; 
        let errors = {};
        let state = this.state;

        if (state.emailId !== "undefined") {
            let lastAtPos = state.emailId.lastIndexOf('@');
            let lastDotPos = state.emailId.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && state.emailId.indexOf('@@') === -1 && lastDotPos > 2 && (state.emailId.length - lastDotPos) > 2)) {
                formIsValid = false;
                errors["emailId"] = "Please enter valid email address";
            }
        }
        if (state.dob === "" || state.dob.length <= 0) {
            errors["dob"] = "Please enter date of birth";
            formIsValid = false;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    validatePasswordForm() {
        let formIsValid = true;
        let errors = {};
        let state = this.state;

        if (state.password === "" || state.password.length <= 0) {
            errors["password"] = "Please enter password";
            formIsValid = false;
        }
        if (state.confirmpassword === "" || state.confirmpassword.length <= 0) {
            errors["confirmpassword"] = "Please confirm password";
            formIsValid = false;
        }
        if((state.password!=='' && state.confirmpassword!== "") 
            && (state.password!=state.confirmpassword)){
            errors["confirmpassword"] = "Password mismatch";
            formIsValid = false;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    viewResetPasswordForm = () => {
        var x = document.getElementById("user-detail");
        var y = document.getElementById("reset-password");
        if (y.style.display === "none") {
            y.style.display = "block";
            x.style.display = "none";
        } else {
            y.style.display = "none";
            x.style.display = "block";
        }
    }

    toggleConfirmPasswordVisibility = () => {
        this.setState(prevState => ({
          confirmPasswordVisible: !prevState.confirmPasswordVisible
        }));
      };

    handleChange(event) {
        if (event.target.name === 'emailId') {
            this.state.errors["emailId"] = "";
            this.setState({ emailId: event.target.value });
        }
        if (event.target.name === 'dob') {
            this.state.errors["dob"] = "";
            this.setState({ dob: event.target.value });
        }
        if (event.target.name === 'otp') {
            this.state.errors["otp"] = "";
            this.setState({ otp: event.target.value });
        }
        if (event.target.name === 'password') {
            this.state.errors["password"] = "";
            this.setState({ password: event.target.value });
        }
        if (event.target.name === 'confirmpassword') {
            this.state.errors["confirmpassword"] = "";
            this.setState({ confirmpassword: event.target.value });
        }
    }

    resetFormField(){
        this.setState({ otp: '', username: '',password: '',confirmpassword: '',emailId: ''});
    }

    setDOB(date) {
        this.setState({ dob: date })
    }

    submit = ()=>{
        if (this.validatePasswordForm()) {
            this.setState({ generateOtpLoader: true })
            return fetch(C.getUrl() + '/user/forgotpassword', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.getData()),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                this.setState({ generateOtpLoader: false });
                if(obj.statusCode == 200){
                    alert("Reset Password Done!");
                    this.resetFormField();
                    this.setState({redirectToLogin: true})
                }else {
                    let errorMessage = "Invalid OTP. Please try again.";
                    if (obj.message) {
                        errorMessage = obj.message; 
                    } else if (obj.statusCode === 401) {
                        errorMessage = "Invalid OTP. Please try again.";
                    } else if (obj.statusCode === 404) {
                        errorMessage = "User not found. Please check your details.";
                    } else if (obj.statusCode === 500) {
                        errorMessage = "Invalid OTP. Please try again..";
                    }
                    alert("Invalid OTP. Please try again"); 
                }
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ generateOtpLoader: false, errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
        }
    }

    getData = () => {
        const { emailId, dob,password,otp} = this.state;
        let jsonData = new Object();
        jsonData['username'] = emailId;
        jsonData['dob'] = dob;
        jsonData['password'] = password;
        jsonData['otp'] = otp;
        return jsonData;
    }

    validateuser = () => {
        if (this.validateForm()) {
            this.setState({ generateOtpLoader: true })
            return fetch(C.getUrl() + '/user/validateDetail', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.getData()),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                this.setState({ generateOtpLoader: false });
                if(obj.statusCode == 200){
                    this.viewResetPasswordForm();
                }else {
                    if (obj.message !== null && obj.message !== ""){
                        let error = obj.message;
                        alert(error)
                    }
                }
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ generateOtpLoader: false, errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
        }
    }

    toggleVisibility = (field) => {
        this.setState(prevState => ({
          [field]: !prevState[field]
        }));
      };

    togglePasswordVisibility() {
        this.setState(prevState => ({ passwordVisible: !prevState.passwordVisible }));
    }

    toggleConfirmPasswordVisibility() {
        this.setState(prevState => ({ confirmPasswordVisible: !prevState.confirmPasswordVisible }));
    }

    render() {
        const { isShowAssociatedWIthDoctor, isDoctor, isOtpModalShown, signInPage, countryArr, genderList, profDegreeList, associateDocList,isPasswordVisible, isConfirmPasswordVisible, confirmPasswordVisible, errors } = this.state;

        if (this.state.redirectToLogin === true) {
            return <Redirect to='sign-in' />
        }
        return (
            <div id="page-login" className='h100 form-body'>
                <Row>
                    <Col lg='7' className="pl-0 pr-0"><div className="bg-image"></div></Col>
                    <Col lg='5' className="pl-0 pr-0">
                        <div className="form-holder">
                            <div className="form-content">
                                <div className="form-items">
                                    <h3 className="text-center w-100">Forgot Password</h3>
                                    <Form className="form">
                                        <div id="user-detail">
                                            <Row className="mt-2">
                                                <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaEnvelope className='' /></span>
                                                        <Form.Control type='email' placeholder='Email Address' name='emailId' onBlur={this._onBlur} onChange={this.handleChange} />
                                                        <div className="invalid-feedback">{this.state.errors["emailId"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaEnvelope className='' /></span>
                                                        <DatePicker
                                                            onChange={date => this.setDOB(date)}
                                                            placeholder="Date of Birth"
                                                            format={dateFormat} style={{ width: "86%" }} />
                                                        <div className="invalid-feedback">{this.state.errors["dob"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="form-button text-center">
                                                        <Button className="btn btn-info" type='button' onClick={() => this.validateuser()}>
                                                            {this.state.generateOtpLoader && (
                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                            )}
                                                            Generate OTP
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="other-links">
                                                        <div className="form-button text-center login-link mb-3 mt-3">
                                                            Already have an account? <a href="#/">Login</a>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div id="reset-password" style={{ display: "none" }}>
                                            <Row className="mt-2">
                                                <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaLock className='' /></span>
                                                        <Form.Control type='number' id="myInput" placeholder='OTP' name='otp' onChange={this.handleChange} />
                                                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}></span>
                                                        <div className="invalid-feedback">{this.state.errors["otp"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                {/* <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaLock className='' /></span>
                                                        <Form.Control type='password' id="myInput" placeholder='Password' name='password' onChange={this.handleChange} />
                                                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}><FaEye className='' onClick={passwordShow}/></span>
                                                        <div className="invalid-feedback">{this.state.errors["password"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaLock className='' /></span>
                                                        <Form.Control type='password' id="" name="confirmpassword" placeholder='Confirm Password' onChange={this.handleChange} />
                                                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}><FaEye className=''/></span>
                                                        <div className="invalid-feedback">{this.state.errors["confirmpassword"]}</div>
                                                    </Form.Group>
                                                </Col> */}
                                                <Col lg='12'>
                    <Form.Group className='input-group'>
                        <span className="input-group-addon"><FaLock className='' /></span>
                        <Form.Control
                            type={this.state.passwordVisible ? 'text' : 'password'} // Toggle between text and password
                            placeholder='Password'
                            name='password'
                            onChange={this.handleChange}
                        />
                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}>
                            <FaEye onClick={this.togglePasswordVisibility} />
                        </span>
                        <div className="invalid-feedback">{this.state.errors["password"]}</div>
                    </Form.Group>
                </Col>
                <Col lg='12'>
                    <Form.Group className='input-group'>
                        <span className="input-group-addon"><FaLock className='' /></span>
                        <Form.Control
                            type={this.state.confirmPasswordVisible ? 'text' : 'password'} // Toggle between text and password
                            name="confirmpassword"
                            placeholder='Confirm Password'
                            onChange={this.handleChange}
                        />
                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}>
                            <FaEye onClick={this.toggleConfirmPasswordVisibility} />
                        </span>
                        <div className="invalid-feedback">{this.state.errors["confirmpassword"]}</div>
                    </Form.Group>
                </Col>
                                                <Col lg='12'>
                                                    <div className="form-button text-center">
                                                        <Button className="btn btn-info" type='button' onClick={this.submit}>
                                                            {this.state.LogingIn && (
                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                            )}
                                                            {!this.state.LogingIn && (
                                                                <FaSignInAlt className='mr-2' size='1.5rem' style={{ verticalAlign: "text-bottom" }} />
                                                            )}
                                                            Submit
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="other-links">
                                                        <div className="form-button text-center login-link mb-3 mt-3">
                                                            Already have an account? <a href="#/">Login</a>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

}